/**
*@title 일정 안내
*@date 2022-02-09
*@author 홍수희
*@desc
*@etc(change)
*/

import React from 'react';
import { t } from 'i18next';

import ueco_logo from '../../images_logos/ueco_logo.svg';


const GuideRegistration = () => {
    return(
        <div className="sect-01-box-01-visitor">
            <div className="sect-tit">{t("vis_guide_guide_title")}</div>
            <div className="tbl-visitor-guide-regi-wrap">
                <table>
                    <colgroup>
                        <col width="48%"/>
                        <col width="4%"/>
                        <col width="48%"/>
                    </colgroup>
                    <tbody>
                    <tr>
                        <td>
                            <div className='tbl-visitor-guide-regi'>
                                <table>
                                    <colgroup>
                                        <col width="20%"/>
                                        <col width="80%"/>
                                    </colgroup>
                                    <tbody>
                                    <tr>
                                        <td colSpan="2" class="center darkgray">
                                            {t("vis_guide_guide_online_title")}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td  class="center padlr bottom gray">
                                            {t("vis_guide_guide_step1_title")}
                                        </td>
                                        <td class="pad bottom">
                                            {t("vis_guide_guide_online_step1")}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="center padlr bottom gray">
                                            {t("vis_guide_guide_step2_title")}
                                        </td>
                                        <td class="pad bottom">
                                            {t("vis_guide_guide_online_step2")}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="center padlr bottom gray">
                                            {t("vis_guide_guide_step3_title")}
                                        </td>
                                        <td class="pad bottom">
                                            {t("vis_guide_guide_online_step3")}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="center padlr bottom gray">
                                            {t("vis_guide_guide_step4_title")}
                                        </td>
                                        <td class="pad bottom">
                                            {t("vis_guide_guide_online_step4")}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </td>
                        <td></td>
                        <td>
                        <div className='tbl-visitor-guide-regi'>
                                <table>
                                    <colgroup>
                                        <col width="20%"/>
                                        <col width="80%"/>
                                    </colgroup>
                                    <tbody>
                                    <tr>
                                        <td colSpan="2" class="center darkgray">
                                            {t("vis_guide_guide_offline_title")}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td  class="center padlr bottom gray">
                                            {t("vis_guide_guide_step1_title")}
                                        </td>
                                        <td class="pad bottom">
                                            {t("vis_guide_guide_offline_step1")}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="center padlr bottom gray">
                                            {t("vis_guide_guide_step2_title")}
                                        </td>
                                        <td class="pad bottom">
                                            {t("vis_guide_guide_offline_step2")}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="center padlr bottom gray">
                                            {t("vis_guide_guide_step3_title")}
                                        </td>
                                        <td class="pad bottom">
                                            {t("vis_guide_guide_offline_step3")}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="center padlr bottom gray">
                                            {t("vis_guide_guide_step4_title")}
                                        </td>
                                        <td class="pad bottom">
                                            {t("vis_guide_guide_offline_step4")}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div className='visitor-guide-regi-txt'>
                    <p>
                        <span>{t("vis_guide_guide_warning1")}</span>
                        <span>&nbsp;</span>
                        <span class="red">{t("vis_guide_guide_warning2")}</span>
                        <span>{t("vis_guide_guide_warning3")}</span>
                    </p>
                </div>
                <div className='visitor-guide-regi-txt'>
                    <p>
                        <span>{t("vis_guide_guide_warning2_1")}</span>
                        <span>&nbsp;</span>
                        <span class="red">{t("vis_guide_guide_warning2_2")}</span>
                        <span>{t("vis_guide_guide_warning2_3")}</span>
                    </p>
                </div>
                {/* <script>
                    document.getElementById('id1').style.backgroundColor='#003F87';
                </script> */}
            </div>
        </div>
    )
}

export default GuideRegistration;